import React from 'react'
import { Link } from 'react-router-dom'
import { useI18n } from '../state/I18nContext'

const Footer: React.FC = () => {
  const { t, locale } = useI18n()
  const l = t.landing.footer
  const home = `/${locale}/`

  return (
    <>
      <footer
        className="px-10 md:px-20 py-12 grid md:grid-cols-[2fr_1fr_1fr] gap-12"
        style={{ background: '#3d2a0a', color: '#f5ece0' }}
      >
        <div>
          <Link
            to={home}
            className="text-xl font-semibold tracking-[0.04em] text-[#c4a882] no-underline"
            style={{ fontFamily: "'Cormorant Garamond', Georgia, serif" }}
          >
            Caladin<em className="italic font-light text-[#9a7249]">hos</em>
          </Link>
          <p className="mt-3 text-[0.82rem] leading-[1.7] text-[#b0a090] max-w-[280px]">
            {t.header.tagline}
          </p>
        </div>
        <div>
          <h5 className="text-[0.72rem] font-medium tracking-[0.14em] uppercase text-[#c4a882] mb-4">
            {l.col1Title}
          </h5>
          <ul className="list-none p-0 m-0">
            {l.col1Links.map(link => (
              <li key={link.anchor} className="mb-2">
                <a
                  href={`${home}#${link.anchor}`}
                  className="text-[0.85rem] text-[#b0a090] no-underline hover:text-[#f5ece0] transition-colors"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h5 className="text-[0.72rem] font-medium tracking-[0.14em] uppercase text-[#c4a882] mb-4">
            {l.col2Title}
          </h5>
          <ul className="list-none p-0 m-0">
            {l.col2Links.map(link => (
              <li key={link.href} className="mb-2">
                <a
                  href={link.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[0.85rem] text-[#b0a090] no-underline hover:text-[#f5ece0] transition-colors"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </footer>
      <div
        className="px-10 md:px-20 py-4 flex justify-between items-center flex-wrap gap-2"
        style={{ background: '#3d2a0a', borderTop: '1px solid rgba(255,255,255,0.08)' }}
      >
        <p className="text-[0.75rem] text-[#b0a090]">{t.footer.rights}</p>
        <p className="text-[0.75rem] text-[#b0a090]">{l.bottomTagline}</p>
      </div>
    </>
  )
}

export default Footer

